import { Drawer, Flex } from 'antd';
import { DrawerProps as ANTDDrawerProps } from 'antd';
import { ReactNode, SyntheticEvent } from 'react';
import { createGlobalStyle, useTheme } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import { StyledMenuCloseAction } from './BottomSheet.style';

type RestrictedANTDDrawerProps = Pick<
  ANTDDrawerProps,
  'open' | 'footer' | 'height' | 'children' | 'onClose' | 'closeIcon'
>;

export interface BottomSheetProps {
  content: RestrictedANTDDrawerProps['children'];
  isOpened?: RestrictedANTDDrawerProps['open'];
  styledTitle?: ReactNode;
  isTopTriggerShown?: boolean;
  isFixedLightBg?: boolean; // to support embed in dark theme
  onHandleClose?: RestrictedANTDDrawerProps['onClose'];
  height?: RestrictedANTDDrawerProps['height'];
  footer?: RestrictedANTDDrawerProps['footer'];
  closeIcon?: RestrictedANTDDrawerProps['closeIcon'];
}

export function BottomSheet({
  isFixedLightBg = false,
  styledTitle,
  isTopTriggerShown = true,
  ...props
}: BottomSheetProps) {
  const GlobalStyle = createGlobalStyle`
    ${({ theme }) => `
      & .ant-drawer-content {
        border-top-left-radius: ${utils.rem(theme.Spacing.Size.Small)};
        border-top-right-radius: ${utils.rem(theme.Spacing.Size.Small)};
        background-color:  ${
          isFixedLightBg ? theme.Color.NeutralsFixed.Paper : theme.Color.Neutrals.Paper
        } !important;
       
      }
    `}
  `;

  return (
    <>
      <GlobalStyle />
      <Drawer
        placement="bottom"
        open={props.isOpened}
        onClose={props.onHandleClose}
        height={props.height}
        footer={props.footer}
        children={props.content}
        closeIcon={props.closeIcon}
        title={
          <Flex vertical>
            {isTopTriggerShown && (
              <Flex justify="center">
                <StyledMenuCloseAction onClick={(e) => props.onHandleClose?.(e)} />
              </Flex>
            )}
            {styledTitle}
          </Flex>
        }
      />
    </>
  );
}
